<template>
  <div class="shop-cart">
    <div v-show="showCart" class="shop-cart-float flex-center" @click="openCart">
      <div class="shop-cart-float-count">
        <i class="el-icon-shopping-cart-full"></i>
        <span>
          &nbsp;{{ totalCount }}&nbsp;{{
            this.$t("message.home.item" /**物品 */)
          }}
        </span>
      </div>
      <!--      <el-button size="mini">${{ totalAmount }}</el-button>-->
      <el-button size="mini">${{ cartTotolSum }}</el-button>
    </div>
    <el-drawer :visible.sync="cartDrawer" direction="rtl" size="400px" custom-class="shop-cart-drawer">
      <div class="flex-start shop-cart-drawer-title" slot="title">
        <i class="el-icon-shopping-cart-full"></i>
        <div>
          <h3>
            {{ totalCount }}&nbsp;{{ this.$t("message.home.item" /**物品 */) }}
          </h3>
          <p class="site-name">{{ this.$t("message.home.myCart") }}</p>
        </div>
      </div>
      <div class="shop-cart-drawer-list" v-if="isLogin && cartItems&&cartItems.length">
        <div v-for="(item, index) in cartItems" :key="index" class="shop-cart-drawer-content flex-start">
          <el-checkbox v-model="item.checked" @change="bindCheckbox(item.skuId, index, item.checked)"></el-checkbox>
          <img :src="$getImageUrl(item.skuThumbnail)" alt="" />
          <div>
            <p class="tit-cart">
              {{ item.skuName }}
            </p>
            <p v-if="item.specifications&&item.specifications.length>0" class="tit-cart">
              <span style="margin-left: 30rpx;"
										v-if="item.specifications&&item.specifications.length>0">[</span><span
										v-for="(it,idx) in item.specifications" :key="idx" >{{"  "+it+" "}}</span><span
										v-if="item.specifications&&item.specifications.length>0">]</span>
            </p>

            <!-- <el-input-number size="mini" key="1" min="1" :precision="0" :max="maxNum"
              v-model="shopCardNumMap[item.Identifier]">
            </el-input-number> -->
            <el-input-number size="mini" :key="item.quantity"  :min="1" v-model="item.quantity" :precision="0"   @change="(value) => bindQuantity(value,item.skuId,index)" >
            </el-input-number>
            <view
              style="font-size:27rpx;width:62rpx;height:52rpx;text-align:center; line-height: 42rpx;"
              @tap="bindMinus(item.skuId,item.quantity)">
              -
            </view>
            <view
              style="width:70rpx;height:52rpx; line-height: 52rpx; border-width:0 2rpx 0 2rpx;border-style:solid;border-color:#eee;text-align:center;">
              {{item.quantity}}
            </view>
            <view style="width:62rpx;height:42rpx; line-height: 52rpx; text-align:center;"
              @tap="bindPlus(item.skuId,item.quantity)">
              +
            </view>
          </div>
          <span class="price" v-if="item.subtotal">
            ${{item.subtotal}}
          </span>
          <i class="el-icon-delete" @click="cart_del(item.skuId,index)"></i>
        </div>
      </div>
      <!-- Guest cart items display -->
      <div class="shop-cart-drawer-list" v-else-if="!isLogin && guestCartItems && guestCartItems.length">
        <div v-for="(item, index) in guestCartItems" :key="'guest-'+index" class="shop-cart-drawer-content flex-start">
          <el-checkbox v-model="item.checked" @change="onGuestCheckChange(index, item.checked)"></el-checkbox>
          <img :src="$getImageUrl(item.goodsImage)" alt="" />
          <div>
            <p class="tit-cart">{{ item.goodsName }}</p>
            <p v-if="item.skuName" class="tit-cart">[{{ item.skuName }}]</p>
            <el-input-number size="mini" :min="1" v-model="item.quantity" :precision="0"
              @change="(value) => onGuestQuantityChange(value, item.skuId, index)">
            </el-input-number>
          </div>
          <span class="price">${{ (item.price * item.quantity).toFixed(2) }}</span>
          <i class="el-icon-delete" @click="onGuestDelete(item.skuId, index)"></i>
        </div>
      </div>
      <div class="shop-cart-drawer-list no-cart" v-else-if="(isLogin && (!cartItems || !cartItems.length)) || (!isLogin && (!guestCartItems || !guestCartItems.length))">
        <img :src="noCart" alt="" />
        <div>{{ this.$t('message.home.购物车还没有商品') }}</div>
        <div class="go-shopping" @click="goShopping">{{ this.$t('message.home.去购物') }}</div>
      </div>
      <div class="shop-cart-drawer-buy flex-center">
        <el-button type="primary" @click="cart_pay">
          {{ this.$t("message.home.checkout") }} ${{ cartTotolSum }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { getCartItemsLocal } from "@/util/shop";
import { numberFormat } from "@/util";
import { BIZ_VUEX } from "@/common";

import {
  get_current,
  add,
  list,
  modify,
  select,
  remove,
  clear,
} from "@/api/order/cart.js"
import {
  recommend
} from "@/api/goods/goods.js"

import { notLogin } from "@/common/pageHook";
import { getGuestCart, getGuestCartCount, removeFromGuestCart, updateGuestCartQuantity } from "@/util/guestCart";

export default {
  name: "Cart",
  data() {
    return {
      num: 1,
      count: 0,
      total: 0,
      cartDrawer: false,
      testData: new Array(30).fill(""),
      showCartRouterPath: [
        "/index",
        "/classification",
        "/commodity",
        "/information",
        "/productDetails",
        "/store",
        "/discounted",
        "/userInfo/dashboard"
      ],
      showCart: false,
      checkMap: {},
      shopCardNumMap: {},
      allNumber: 0,
      noCart: require("@/assets/image/no-cart-item.jpg"),
      maxNum: 0,


      ///////////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      // searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      // objsList: [],
      page: 1,
      minusStatuses: ['disabled', 'disabled', 'normal', 'normal', 'disabled'],
      objsData: [],
      datas: [],
      selectedAllStatus: false,
      carts: [],
      toastHidden: false,
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      objsList: [],
      loadType: "load",
      queryParams: {
        pageNumber: 0,
        pageSize: 10,
      },
      // currentCart: {},
      cartSubTotal: 0,
      recommendGoodss: [],
      // cartItems:[],
      guestCartItems: [],

      ///////////////////////////////////////////////////////////////////////////
    };
  },
  created() {


    // var uInfo = uni.getStorageSync('userInfoStorage');
    if (this.isLogin) {
      this.cart_list();
      // this.cartItems=this.$store.state.cartItems;
      this.initCartData();
      // this.goods_recommend();
    } else {
      this.loadGuestCart();
    }

    // this.$nextTick(() => {
    //   this.init();
    // });
    // setTimeout(()=>{
    //   this.maxNum = Number(localStorage.getItem('maxBuy') || 500) 
    // },1500)






  },
  computed: {
    ...mapGetters({ cartItems: "cartItems" }),
    ...mapGetters({ currentCart: "currentCart" }),
    ...mapGetters(["isLogin"]),
    ...mapGetters({ userInfo: "userInfo" }),
    totalAmount() {
      return numberFormat(
        this.cartItems.reduce(
          (a, b) => a + (b.price ?? b.discountPrice ?? b.sellingPrice),
          0
        )
      );
    },
    totalCount() {
      let amount = 0;

      if (!this.isLogin) {
        return this.guestCartItems ? this.guestCartItems.length : 0;
      }

      // const checkData = this.cartItems.filter(
      //   (item) => this.checkMap[item.Identifier]
      // );
      amount = this.cartItems ? this.cartItems.length : 0;
      // checkData.forEach((item) => {
      //   amount += this.shopCardNumMap[item.Identifier];
      // });
      return amount;
    },
    totalCheckAmount() {
      // let amount = 0;
      // const checkData = this.cartItems.filter(
      //   (item) => this.checkMap[item.Identifier]
      // );

      // checkData.forEach((item) => {
      //   amount = this.$big(amount).plus(
      //     this.$big(this.shopCardNumMap[item.Identifier]).times(
      //       item.price ?? item.discountPrice ?? item.sellingPrice
      //     ))
      //     // numberFormat(item.price ?? item.discountPrice ?? item.sellingPrice);
      // });
      return 0;
    },
    cartTotolSum() {
      let total = 0;

      // 游客购物车
      if (!this.isLogin) {
        if (this.guestCartItems && this.guestCartItems.length) {
          for (var j = 0; j < this.guestCartItems.length; j++) {
            if (this.guestCartItems[j].checked !== false) {
              total += this.guestCartItems[j].price * this.guestCartItems[j].quantity;
            }
          }
          return total;
        }
        return 0;
      }

      if (this.cartItems && this.cartItems.length) {
        for (var i = 0; this.cartItems && i < this.cartItems.length; i++) {
          if (this.cartItems[i].checked) {
            total += this.cartItems[i].price*this.cartItems[i].quantity;
          }
        } // 写回经点击修改后的数组
        return total;
      } else {
        return 0;
      }

    },
  },
  watch: {
    $route: {
      handler(newValue) {
        this.showCart =
          this.showCartRouterPath.indexOf(newValue.path) >= 0;
      },
      deep: true,
    },
    // cartItems: {
    //   handler(newValue) {
    //     const obj = {};
    //     const numObj = {};
    //     newValue.forEach((item) => {
    //       obj[item.Identifier] = true;
    //       numObj[item.Identifier] = item.count || 1;
    //     });

    //     this.checkMap = { ...obj, ...this.checkMap };
    //     this.shopCardNumMap = { ...numObj, ...this.shopCardNumMap };
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    checkMap() {
    },
    cartDrawer(val) {
      function handler(e) {
        e.preventDefault();
      }
      if (val) {

        if (this.isLogin) {
          this.cart_list();
        } else {
          this.loadGuestCart();
        }

        document.body.style.overflow = "hidden";
        document.addEventListener("scroll", handler, false);
      } else {

        if (this.isLogin) {
          this.cart_list();
        } else {
          this.loadGuestCart();
        }
        document.body.style.overflow = "";
        document.addEventListener("scroll", handler, true);
      }
    },
  },
  methods: {
    // ...mapMutations("cart", ["updateCartItems", "updateCheckProductPay"]),
    ...mapMutations({
        setCartItems:"SETCARTITEMS",
        updateCartItems:"UPDATECARTITEMS",
        removeCartItems:"REMOVECARTITEMS"
    }),
    numberFormat,
    openCart() {
      this.cartDrawer = true;

      setTimeout(() => { }, 500);
    },
    chlick(i) {
    },
    goShopping() {
      this.cartDrawer = false;
      this.$router.push('/index')
    },
    /**
     * 不清楚为什么更新那么缓慢，先采用临时方案处理问题
     */
    init() {
      setTimeout(() => {
        this.initCartItemsData();
        this.initCheckProductPay();
      }, 1500);
    },
    initCartData() {
      const cartItems = this.$store.state.cartItems;
      // const cartItems = getCartItemsLocal().then(result =>{
      //   return result;
      // });
      // if (cartItems && cartItems.length) {
      //   this.updateCartItems(cartItems);
      // }
    },
    initCheckProductPay() {
      const vuexData = localStorage.getItem(BIZ_VUEX);
      if (vuexData) {
        const vuexObj = JSON.parse(vuexData);
        const checkProductPay = vuexObj.cartItems.checkProductPay;
        if (checkProductPay && checkProductPay.length) {
          this.updateCheckProductPay(checkProductPay);
        }
      }
    },
    getCheckInfo() {
      let checkByStore = {};
      const checkData = this.cartItems.filter(
        (item) => this.checkMap[item.Identifier]
      );
      checkData.forEach((item) => {
        if (!checkByStore[item.seller.id]) {
          checkByStore[item.seller.id] = {
            title: item.seller.name,
            checkList: [],
            checkAll: true,
            isIndeterminate: false,
            list: [],
          };
        }
        checkByStore[item.seller.id].checkList.push(item.Identifier);
        checkByStore[item.seller.id].list.push({
          ...item,
          ...{ checkTotal: this.shopCardNumMap[item.Identifier] },
        });
      });
      return Object.values(checkByStore);
    },
    pay() {
      if (this.getCheckInfo().length === 0) {
        this.$message({
          message: this.$t(
            "message.home.unSelectedProduct" /**您还未选中商品 */
          ),
          type: "error",
        });
        return;
      }
      if (this.totalCheckAmount) {
        this.cartDrawer = false;
        this.updateCheckProductPay(this.getCheckInfo());
        this.$router.push("/settlement");
      }
    },
    del(index) {
      const data = JSON.parse(JSON.stringify(this.cartItems));
      data.splice(index, 1);
      this.updateCartItems(data);

      // const delItem = this.cartItems.splice(index, 1);
      // let cartItemsData = getCartItemsLocal();

      // if (cartItemsData && cartItemsData.length) {
      //   cartItemsData = cartItemsData.filter(
      //     (item) => item.Identifier !== delItem.Identifier
      //   );
      //   this.updateCartItems(cartItemsData);
      //   this.$delete(this.checkMap, delItem.Identifier);
      // }
    },


    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    cart_list() {
      this.loading=true;
      // let currentCartStr= uni.getStorageSync('currentCart');
      // if(currentCartStr){
      // 	this.currentCart = JSON.parse(currentCartStr);
      // }
      if (this.currentCart && this.currentCart.id) {
        get_current({
          "currentCartId": this.currentCart.id
        }).then(response => {

          this.setCartItems(response.data.data.cartItems);

          this.loading=false;
          //下拉加载
          // if (this.loadType === "reach") {
          // 	const newObjsList = response.data.data.content;
          // 	newObjsList.forEach(item => this.objsList.push(item));
          // 	this.searchLoading = false;
          // 	//加载
          // } else if (this.loadType === "load") {
          // this.set= response.data.data.cartItems;
          //下拉刷新
          // } else if (this.loadType === "pullDown") {
          // 	uni.stopPullDownRefresh();
          // }
          // this.cartTotolSum();
        });
      }
    },
    cart_del: function (skuId,index) {
      let that = this;
      this.removeCartItems(index);

            remove({
              "skuId": skuId,
              "currentCartId": that.currentCart.id
            }).then(response => {
              that.objsList = [];
              that.cart_list();
              // uni.showToast({
              //   title: this.messages['common_deleteSuccess'],
              // })
            }).catch(error => {
              this.loading=false;
              console.error("error", error);
              // uni.showToast({
              //   title: that.messages['common_message_unknownError'],
              //   duration: 2000
              // });
            })

    },
    // cart_totol_sum: function() {
    // 	var objsList = this.cartItems; // 计算总金额
    // 	var total = 0;
    // 	for (var i = 0; objsList && i < objsList.length; i++) {
    // 		if (objsList[i].checked) {
    // 			total += objsList[i].price;
    // 		}
    // 	} // 写回经点击修改后的数组
    // 	this.cartSubTotal = total;
    // },
    //商品数量 -  减少
    bindQuantity: function (quantity,skuId,index) {
      // 如果只有1件了，就不允许再减了 
      if (quantity < 0) {
        return
      }
      this.updateCartItems({'index':index,'quantity':quantity});
      this.loading=true;
      modify({
        "skuId": skuId,
        "quantity": quantity,
        "currentCartId": this.currentCart.id
      }).then(response => {
        this.loading=false;
        this.objsList = [];
        this.cart_list();
        // this.cartTotolSum();
      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        //   title: this.messages['common_message_unknownError'],
        //   duration: 2000
        // });
      })
    },


    bindCheckbox: function (skuIds, index, checked) {

      this.updateCartItems({'index':index,'checked':checked});

      // if (index) {
      // 	this.objsList[index].checked = checked;
      // }
      this.loading=true;
      select({
        "skuIds": skuIds,
        "checked": checked,
        "currentCartId": this.$store.state.currentCart.id,
      }).then(response => {
        this.loading=false;
        // this.objsList = [];
        // this.cart_list();
      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    bindSelectAll: function (e) {
      var selectedAllStatus = !this.selectedAllStatus; // 取反操作
      var objsList = this.objsList;
      var skuIds = "";
      for (var i = 0; i < objsList.length; i++) {
        objsList[i].checked = selectedAllStatus;
        skuIds += objsList[i].skuId + ",";
      }
      this.selectedAllStatus = selectedAllStatus;
      this.bindCheckbox(skuIds, null, selectedAllStatus)
      this.cartTotolSum();
    },

    cart_pay() {
      // if (this.getCheckInfo().length === 0) {
      //   this.$message({
      //     message: this.$t(
      //       "message.home.unSelectedProduct" /**您还未选中商品 */
      //     ),
      //     type: "error",
      //   });
      //   return;
      // }

      // 游客用户：只要有游客购物车商品就可以跳转到结算（GuestCheckout会处理注册）
      if (!this.isLogin) {
        if (this.guestCartItems && this.guestCartItems.length > 0) {
          this.cartDrawer = false;
          this.$router.push("/settlement");
        } else {
          this.$message({
            message: this.$t('message.home.购物车还没有商品') || 'Cart is empty',
            type: 'warning',
          });
        }
        return;
      }

      if (this.cartTotolSum) {
        this.cartDrawer = false;
        // this.updateCheckProductPay(this.getCheckInfo());
        this.$router.push("/settlement");
      }
    },
    // bindCheckout: function() {
    // 	// 初始化toastStr字符串
    // 	var toastStr = ''; // 遍历取出已勾选的cid
    // 	for (var i = 0; i < this.carts.length; i++) {
    // 		if (this.carts[i].selected) {
    // 			toastStr += this.carts[i].id;
    // 			toastStr += ',';
    // 		}
    // 	}
    // 	if (toastStr == '') {
    // 		uni.showToast({
    // 			title: '请选择要结算的商品！',
    // 			duration: 2000
    // 		});
    // 		return false;
    // 	} //存回data
    // 	uni.navigateTo({
    // 		url: '../order/pay?cartId=' + toastStr
    // 	});
    // },

    onErrorImg(item) {
      this.$set(item, 'thumbnail', "/static/images/default_thumbnail.jpg");
      this.$set(item, 'logo', "/static/images/default_thumbnail.jpg");
    },
    //喜欢推荐案例
    goods_recommend() {
      this.loading=true;
      recommend({
        "rankingType": "SALES",
        "count": 10
      }).then(response => {
        this.loading=false;
        this.recommendGoodss = response.data.data.recommendGoodss;

      }).catch(error => {
        this.loading=false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },

    /////////////////////////////////////////////////////////////////////////////////////////////////

    // ==================== 游客购物车方法 ====================

    /**
     * 从 localStorage 加载游客购物车
     */
    loadGuestCart() {
      const items = getGuestCart();
      // 确保每个项都有 checked 属性
      this.guestCartItems = items.map(item => ({
        ...item,
        checked: item.checked !== false
      }));
    },

    /**
     * 游客购物车 - 修改数量
     */
    onGuestQuantityChange(quantity, skuId, index) {
      if (quantity < 1) return;
      updateGuestCartQuantity(skuId, quantity);
      this.loadGuestCart();
    },

    /**
     * 游客购物车 - 删除商品
     */
    onGuestDelete(skuId, index) {
      removeFromGuestCart(skuId);
      this.loadGuestCart();
    },

    /**
     * 游客购物车 - 勾选/取消勾选
     */
    onGuestCheckChange(index, checked) {
      if (this.guestCartItems[index]) {
        this.$set(this.guestCartItems, index, {
          ...this.guestCartItems[index],
          checked: checked
        });
      }
    },

    /////////////////////////////////////////////////////////////////////////////////////////////////


  },
};
</script>

<style lang="scss">
html[dir="rtl"] {
  .el-icon-shopping-cart-full {
    margin-right: 0;
    margin-left: 16px;
  }

  .shop-cart-drawer-content .price {
    padding-left: 0;
    padding-right: 15px;
  }

  .shop-cart {
    &-float {
      right: auto;
      left: 0;
      border-radius: 0px 40px 40px 0px;
      padding-left: 0;
      padding-right: 15px;
    }

    .el-drawer.rtl {
      right: auto;
      left: 0;
    }
  }
}

.shop-cart {
  &-float {
    width: 108px;
    height: 76px;
    background-color: var(--color-main);
    border-radius: 40px 0px 0px 40px;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    flex-direction: column;
    padding-left: 15px;
    cursor: pointer;
    z-index: 999;

    &-count {
      font-size: 12px;
      color: var(--color-white);
      margin-bottom: 10px;

      .el-icon-shopping-cart-full {
        font-size: 16px;
      }
    }

    .el-button {
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap;
      width: 67px;
      height: 23px;
      color: var(--color-main);
      background-color: var(--color-white);
      border: 1px solid var(--color-white);
      padding: 0;
    }
  }
}

.shop-cart-drawer {
  position: relative;

  &-title {
    .el-icon-shopping-cart-full {
      font-size: 24px;
      color: var(--color-main);
      margin-right: 16px;
    }

    h3 {
      font-weight: 500;
      font-size: 14px;
      color: var(--color-title);
    }

    .site-name {
      font-size: 12px;
      font-weight: 400;
      color: var(--color-subtitle);
      margin-top: 4px;
    }
  }

  &-list {
    height: calc(100vh - 150px);
    overflow: auto;

    &.no-cart {
      display: flex;
      box-sizing: border-box;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 320px;
      }

      div {
        // width: 320px;
        text-align: center;
        font-size: 24px;
      }

      .go-shopping {
        border: 1px solid var(--color-main);
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        color: var(--color-main);
        font-weight: 500;
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }

  &-content {
    padding: 0 12px;
    margin-bottom: 30px;

    img {
      width: 60px;
      height: 60px;
      margin: 0 10px;
      object-fit: contain;
    }

    >div {
      width: 170px;
    }

    .tit-cart {
      flex: 1;
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 400;
      font-size: 12px;
      color: var(--color-black);
      margin-bottom: 10px;
    }

    .price {
      color: var(--color-price);
      font-size: 14px;
      font-weight: 400;
      flex: 1;
      padding-left: 15px;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }

    .el-icon-delete {
      font-size: 18px;
      color: var(--color-subtitle);
    }

    .el-input-number__decrease,
    .el-input-number__increase {
      background-color: var(--color-main) !important;
      color: var(--color-white);
      border: 1px solid var(--color-main) !important;
      border-radius: 4px !important;
      width: 20px !important;
      height: 20px !important;
      line-height: 20px;
    }

    .el-input-number--mini {
      width: 80px;
    }

    .el-input__inner {
      border: 0 !important;
      padding: 0 20px !important;
      height: 20px !important;
      line-height: 20px !important;
      position: relative;
      top: -3px;
    }

    .el-input-number__decrease:hover,
    .el-input-number__increase:hover {
      color: var(--color-white);
    }
  }

  &-buy {
    width: 100%;
    position: absolute;
    bottom: 10px;
    left: 0;

    .el-button {
      width: 312px;
      height: 40px;
      font-weight: 700;
      font-size: 14px;
    }
  }

  .el-drawer__header {
    border-bottom: 1px solid var(--color-border);
    padding-bottom: 14px;
    margin-bottom: 15px;
  }
}
</style>
